export const useAnalyticsCharts = (activeTab, charts, hasTabs) => {
    if (!hasTabs) {
        const defaultOrder = [
            'profitChart',
            'membershipsTotalMembersChart',
            'membershipsMembersChangeChart',
            'membershipsTotalFreeMembersChart',
            'membershipsFreeMembersChangeChart',
            'contributionsChart',
            'contributionValueChart',
            'topProductsChart',
            'salesByCountryChart',
            'membershipsTopTiersChart',
            'paymentMethodUsedChart',
            'conversionRatesChart',
            'uniqueVisitorsChart',
            'salesByTrafficSourceTableChart',
            'sessionsByTrafficSourceChart',
            'salesBySocialSourceTableChart',
            'sessionsBySocialSourceChart',
        ];
        return defaultOrder
            .map((name) => ({
            name,
            chart: charts[name],
        }))
            .filter(({ chart }) => chart !== undefined);
    }
    const visibleCharts = {
        overview: [
            'totalProfitChart',
            'shopOrdersChart',
            'conversionRatesChart',
            'uniqueVisitorsChart',
            'membershipsTotalMembersChart',
            'contributionValueChart',
            'topProductsChart',
            'salesByCountryChart',
        ],
        shop: [
            'shopProfitChart',
            'shopOrdersChart',
            'conversionRatesChart',
            'uniqueVisitorsChart',
            'contributionValueChart',
            'topProductsChart',
            'salesByCountryChart',
            'paymentMethodUsedChart',
            'salesByTrafficSourceTableChart',
            'sessionsByTrafficSourceChart',
            'salesBySocialSourceTableChart',
            'sessionsBySocialSourceChart',
        ],
        memberships: [
            'membershipsProfitChart',
            'membershipsTotalMembersChart',
            'membershipsMembersChangeChart',
            'membershipsTotalFreeMembersChart',
            'membershipsFreeMembersChangeChart',
            'membershipsTransactionsChart',
            'membershipsTopTiersChart',
        ],
    };
    const activeCharts = visibleCharts[activeTab] || [];
    return activeCharts
        .map((chartName) => ({
        name: chartName,
        chart: charts[chartName],
    }))
        .filter(({ chart }) => chart !== undefined);
};
